import { Dispatch } from "redux";
import api from "../../api/api";

/* ACTION TYPES */

export const FETCH_COURSE_DETAILS_REQUEST = "FETCH_COURSE_DETAILS_REQUEST";
export const FETCH_COURSE_DETAILS_SUCCESS = "FETCH_COURSE_DETAILS_SUCCESS";
export const FETCH_COURSE_DETAILS_FAILURE = "FETCH_COURSE_DETAILS_FAILURE";

export const FETCH_LESSONS_REQUEST = "FETCH_LESSONS_REQUEST";
export const FETCH_LESSONS_SUCCESS = "FETCH_LESSONS_SUCCESS";
export const FETCH_LESSONS_FAILURE = "FETCH_LESSONS_FAILURE";

export const FETCH_STUDENTS_REQUEST = "FETCH_STUDENTS_REQUEST";
export const FETCH_STUDENTS_SUCCESS = "FETCH_STUDENTS_SUCCESS";
export const FETCH_STUDENTS_FAILURE = "FETCH_STUDENTS_FAILURE";


/* FETCH COURSE DETAILS */

export const fetchCourseDetails =
  (courseId: number, token: string) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: FETCH_COURSE_DETAILS_REQUEST });

      const response = await api.get(`courses/get-course/${courseId}/`, {
        headers: { Authorization: `Token ${token}` },
      });

      dispatch({
        type: FETCH_COURSE_DETAILS_SUCCESS,
        payload: response?.data?.data,
      });
    } catch (error: any) {
      dispatch({
        type: FETCH_COURSE_DETAILS_FAILURE,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };


/* FETCH LESSON DETAILS */

export const fetchLessons =
  (courseId: number, token: string) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: FETCH_LESSONS_REQUEST });

      const response = await api.get(
        `lessons/get-all-lessons/course/${courseId}/`,
        {
          headers: { Authorization: `Token ${token}` },
        }
      );

      dispatch({
        type: FETCH_LESSONS_SUCCESS,
        payload: response?.data?.data,
      });
    } catch (error: any) {
      dispatch({
        type: FETCH_LESSONS_FAILURE,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };


/* FETCH STUDENTS */

export const fetchStudents =
  (courseId: number, token: string, is_ls_advisor: boolean, teacher_id?: number) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: FETCH_STUDENTS_REQUEST });
      let url =  `courses/teacher/enroll-course-requests/?course_id=${courseId}&status=1,4,5&page=1&is_ls_advisor=${is_ls_advisor}`;
      if (teacher_id) {
        url += `&teacher_id=${teacher_id}`;  //append teacher_id for admin when fetching students of advisor and ls on admin side to see assignment submissions
      }
      const response = await api.get(url,
        {
          headers: { Authorization: `Token ${token}` },
        }
      );

      dispatch({
        type: FETCH_STUDENTS_SUCCESS,
        payload: response?.data?.data,
      });
    } catch (error: any) {
      dispatch({
        type: FETCH_STUDENTS_FAILURE,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };